import React, { useState } from 'react';
import { Container, Form, Button } from 'react-bootstrap';
import { submitForm } from '../api/submitForm';
import './RequestForm.less';
import { useDispatch } from 'react-redux';
import { triggerApiFetch } from '../redux/actions/wishesActions';

const RequestForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    wish: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  const dispatch = useDispatch();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const query = {
        'entry.171118686': formData.name,  
        'entry.1366657488': formData.email,
        'entry.218997464': formData.phone,
        'entry.1868409515': formData.message,
        'entry.618260365': formData.wish
    };

    try {
        await submitForm(query);
        alert('Form submitted successfully');
        setFormData({ name: '', email: '', phone: '', message: '', wish: '' });
        dispatch(triggerApiFetch());
    } catch {
        alert('Failed to submit form');
    }
  };

  return (
    <Container className="mt-5 request-form">
      <h1>意見回饋</h1>
      <Form onSubmit={handleSubmit}>
        <Form.Group controlId="formName">
          <Form.Label>姓名</Form.Label>
          <Form.Control
            type="text"
            placeholder="請輸入如何稱呼"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formEmail" className="mt-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="請輸入電子信箱"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formPhone" className="mt-3">
          <Form.Label>手機</Form.Label>
          <Form.Control
            type="phone"
            placeholder="請輸入手機號碼"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group controlId="formMessage" className="mt-3">
          <Form.Label>意見/建議</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="請輸入意見/建議，您的指教與肯定是我們進步的動力"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group controlId="formWish" className="mt-3">
          <Form.Label>許願功能/系統改善</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="歡迎寫下你希望未來新增的功能或系統優化的目標，例如票價查詢、路線建議等等"
            name="wish"
            value={formData.wish}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" type="submit" className="mt-3 submit-btn">
          送出
        </Button>
      </Form>
    </Container>
  );
}

export default RequestForm;
